<template>
  <div id="publishing-special-issue-application">
    <div class='ipub-h1 mar-b-12'>
      Special Issues Application
    </div>
    <ipub-row :gutter="[12, 16]">
      <ipub-col :span="2">
        <ipub-select v-model="params.journalId"
                     placeholder="Select Journal"
                     @change="changeJournal"
                     :options="journalList" />
      </ipub-col>
      <ipub-col :span="10">
        <site-search-group v-model.trim="params.keyword"
                           placeholder="Search by special issue's title, guest editor"
                           @search="getList()"
                           @clear="handleClear" />
      </ipub-col>
    </ipub-row>
    <div class="relative ipub-p1 ipub-list-tab mar-b-30">
      <a @click="changeStatus('')"
         :class="['ipub-list-tab--status',params.handle===''?'active':'']">All Status</a>
      <a @click="changeStatus('UNHANDLED')"
         :class="['ipub-list-tab--status',params.handle==='UNHANDLED'?'active':'']">Pending</a>
      <a @click="changeStatus('ACCEPTED')"
         :class="['ipub-list-tab--status',params.handle==='ACCEPTED'?'active':'']">Accepted</a>
      <a @click="changeStatus('REFUSED')"
         :class="['ipub-list-tab--status',params.handle==='REFUSED'?'active':'']">Rejected</a>
    </div>
    <div class="page-content">
      <ipub-table :columns="columns"
                  fixed
                  :pagination="pagination"
                  :dataSource="dataSource">
        <template v-slot:roles="{text}">
          {{editorialBoard[text]}}
        </template>
        <template v-slot:status="{text}">
          <ipub-label size="small"
                      cover
                      style="width:80px"
                      type="danger"
                      v-if="text === 'REFUSED'">Refused</ipub-label>
          <ipub-label size="small"
                      type="success"
                      cover
                      style="width:80px"
                      v-else-if="text === 'ACCEPTED'">Accepted</ipub-label>
          <ipub-label size="small"
                      type="default"
                      cover
                      style="width:80px"
                      v-else-if="text === 'UNHANDLED'">Pending</ipub-label>
        </template>
        <template v-slot:applier="{record}">
          <ipub-tooltip style="width:100%"
                        placement="bottomLeft"
                        omis="omis"
                        :label="`${record.applierFirstName} ${record.applierLastName}`" />
        </template>
        <template v-slot:actions="{ record }">
          <ipub-tooltip class="border-right">
            <div slot="title">Details</div>
            <ipub-icon type="iconViewDetails"
                       @click="detail(record)" />
          </ipub-tooltip>
          <template v-if="record.handle === 'UNHANDLED'">
            <ipub-tooltip v-if="user.codeList&&user.codeList.includes('WEBSITE.SPECIAL_ISSUES.APPLY.ACCEPT')"
                          class="border-right">
              <div slot="title">Accept</div>
              <ipub-icon type="iconAble"
                         @click="accept(record)" />
            </ipub-tooltip>
            <ipub-tooltip v-if="user.codeList&&user.codeList.includes('WEBSITE.SPECIAL_ISSUES.APPLY.REFUSE')"
                          class="border-right">
              <div slot="title">Refuse</div>
              <ipub-icon type="iconDisable"
                         @click="reject(record)" />
            </ipub-tooltip>
          </template>
          <template v-else>
            <ipub-icon v-if="user.codeList&&user.codeList.includes('WEBSITE.SPECIAL_ISSUES.APPLY.ACCEPT')"
                       class="line-color"
                       type="iconAble" />
            <ipub-icon v-if="user.codeList&&user.codeList.includes('WEBSITE.SPECIAL_ISSUES.APPLY.REFUSE')"
                       class="line-color"
                       type="iconDisable" />
          </template>
        </template>
      </ipub-table>
    </div>
    <Detail :isVisable="isVisable"
            :inputData="inputData"
            @cancel="cancel" />
    <SendEmail :isVisable="showSendEmail"
               :inputData="inputData"
               event="APPROVAL_OF_SPECIAL_ISSUE_APPLICATION"
               @cancel="cancel" />
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
